<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent scrollable>
      <v-card>
        <v-card-title primary-title> ReinCorporar Estudiante </v-card-title>
        <v-card-text>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="faltantes"
            sort-by="full_name"
            :itemsPerPage="-1"
            show-select
            :search="search">
            <template v-slot:top v-if="faltantes.length">
              <v-text-field outlined dense v-model="search" label="Buscar en la lista" class="mx-4 mt-3"></v-text-field>
            </template>
            <!-- <template v-slot:[`item.options`]="{ item }"></template> -->
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top v-if="selected.length">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="loading"
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                outlined
                rounded
                @click="saveEnroll">
                <v-icon class="ma-2">mdi-content-save-all</v-icon> Realizar Reincoporacion A Modulo
              </v-btn>
            </template>
            Reinscorporar los Siguientes Estudiantes
          </v-tooltip>

          <v-btn color="blue darken-1" outlined rounded @click="closeDialog">
            Cerrar <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import xaxios from 'axios';
import gql from 'graphql-tag';
import { mapState } from 'vuex';
export default {
  props: {
    programa: { type: Object, default: () => ({}) },
    inscritosByPrograma: { type: Array, default: () => [] },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      faltantes: [],
      selected: [],
      search: '',
      modulo: null,
      api_rest: process.env.VUE_APP_API_REST,
      // api_rest_moodle: process.env.UE_APP_API_REST_MOODLE,

      headers: [
        { text: 'Nombre Completo', value: 'full_name' },
        { text: 'Moodle Username', value: 'estudiante.usuario_moodle' },
        { text: 'Email', value: 'estudiante.email' },
        { text: 'Telefono', value: 'estudiante.telefono1' },
        // { text: 'Estado', value: 'status' },
        // { text: '', value: 'estado' },
      ],

      datamsg: '',
      plataforma: {},
      plataformas: [],
      msgerr: '',
    };
  },
  watch: {
    UNIDAD_NEGOCIO_ID() {
      this.plataformas = [];
      this.getDatosPlataformas();
    },
  },
  computed: {
    ...mapState({
      // programa: (state) => state.programa.value,
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
  },

  methods: {
    showThisView(inscritos, modulo) {
      this.modulo = modulo;
      inscritos = inscritos.map((i) => i.inscripcion_id); // remove
      this.faltantes = this.inscritosByPrograma.filter((ins) => !inscritos.includes(ins.id));
      this.faltantes = this.faltantes.map((ins) => ({
        ...ins,
        full_name: `${ins.estudiante.nombres} ${ins.estudiante.pri_apellido} ${ins.estudiante.seg_apellido}`,
      }));
      this.dialog = true;
    },
    reinstatementStudent(inscripcion) {
      // window.console.log('reinstatementStudent', inscripcion);
      xaxios
        .post(`${this.api_rest}/esam/inscripcion/modulo/tipo`, {
          inscripcion_modulo_id: inscripcion.id,
          tipo_ingreso: 1,
        })
        .then(({ data }) => {
          this.$emit('increase', inscripcion);
          // window.console.log('exec', inscripcion);
          this.$root.$notify.show(`${data.result}: Estudiante ${inscripcion.estudiante.nombres} Reincoporado`, {
            color: 'success',
          });
          this.closeDialog();
        })
        .catch((data) => this.$root.$notify.show(`${data.error}`, { color: 'red', y: 'top' }));
    },
    async saveEnroll() {
      if (this.selected.length == 0)
        return this.$root.$notify.show(`Debe Seleccionar Estudiantes de la Lista`, {
          color: 'primary',
          y: 'bottom',
          x: 'left',
        });
      if (await this.$root.$confirm.open('Realizar La Reinscorporacion', 'Estas seguro?', { color: 'orange' })) {
        const url = `${this.api_rest}/esam/inscripcion/modulo/student`;
        this.selected.forEach((inscripcion) => {
          let { estudiante } = inscripcion;
          // window.console.log('saveEnroll', estudiante);

          let formData = {
            inscripcion_id: inscripcion.id,
            programa_id: this.programa.id,
            programa_modulo_id: this.modulo.id, // if(0 || 1 ) INSCRIPCION = 0, PROGRAMADO = 1, EN DESARROLLO = 2, POSTERGADO = 3, CONCLUIDO = 4,
            estudiante_id: estudiante.id,
            username: estudiante.usuario_moodle,
            observacion: '',
          };

          xaxios.post(url, formData).then(() => {
            this.loading = true;
            // window.console.log('inscrito');
            xaxios
              .get(`${this.api_rest}/esam/inscripcion/modulo/id/${this.modulo.id}`)
              .then(({ data: { inscripciones } }) => {
                let inscrito = inscripciones.find(
                  (ins) => ins.inscripcion_id == inscripcion.id && ins.estudiante_id == estudiante.id,
                );
                // window.console.log('get inscripciones');
                this.reinstatementStudent(inscrito);
              });
            if (this.modulo.course_id) {
              this.msgerr = '';
              if (!this.plataforma.id) {
                this.getDatosPlataformas();
              }
              const url_moodle = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(
                /\/$/,
                '',
              )}/plataformas/${this.plataforma.id}/enrolment`;
              const formEnroll = {
                username: estudiante.usuario_moodle,
                course_id: this.modulo.course_id,
                user_role: 5,
              };
              // window.console.log('data send for moodle sevice', formEnroll, url_moodle);
              xaxios
                .post(url_moodle, formEnroll)
                .then(() => this.$root.$notify.show('Estudiante Inscrito en Sistema y Moodle'));
            }
          });
        });
      }
    },
    closeDialog() {
      this.faltantes = [];
      this.selected = [];
      this.modulo = null;
      this.dialog = false;
      this.loading = false;
    },

    getDatosPlataformas() {
      this.$apollo
        .query({
          query: gql`query { getPlataformas(estado: true,unidad_negocio_id: ${this.UNIDAD_NEGOCIO_ID}) { id nombre direccion unidad_negocio_id estado }}`,
        })
        .then(({ data: { getPlataformas } }) => {
          if (!this.programa.plataforma_id) {
            // window.console.log('No asignado plataforma.', this.programa);
            return;
          }
          this.plataformas = getPlataformas;
          let plataforma_id = this.programa.plataforma_id;
          this.plataforma = this.plataformas.find((x) => x.id == plataforma_id);
          if (this.plataforma) {
            this.datamsg = `<b>Plataforma</b>: ${this.plataforma.nombre}`;
          }
        })
        .catch((err) => this.$root.$notify.show(`ERROR: getPlataformas(Reinstantement) ${err}`));
    },
  },
  mounted() {
    this.getDatosPlataformas();
  },
};
</script>

<style>
</style>